/* Lave-Casquette — bundle maison, sans app.
   Les PRIX de palier sont tenus par des remises automatiques Shopify (montant fixe) :
   on ajoute N × la variante au prix unitaire, Shopify applique la remise du palier.
   Les 2 guides PDF partent en lignes à 0 $ avec la propriété cachée `_offre`
   (c'est elle qui fait afficher « Gratuit » dans le tiroir — patch déjà en place). */
(function () {
  const racine = document.querySelector('[data-scb]');
  if (!racine) return;
  const conf = JSON.parse(racine.querySelector('[data-scb-conf]').textContent);

  /* le shop peut afficher une autre devise que la devise de base */
  const TAUX = (window.Shopify && window.Shopify.currency
                && parseFloat(window.Shopify.currency.rate)) || 1;
  const enDevise = (c) => Math.round(c * TAUX);

  function argent(cents) {
    const n = (cents / 100).toFixed(2);
    const virgule = /\{\{\s*amount_with_comma_separator\s*\}\}|\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/
      .test(conf.format);
    return conf.format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/,
                               virgule ? n.replace('.', ',') : n);
  }

  const tiers = [...racine.querySelectorAll('[data-scb-tier]')];
  const btn = racine.querySelector('[data-scb-atc]');
  const eco = racine.querySelector('[data-scb-eco]');
  const err = racine.querySelector('[data-scb-err]');
  let choisi = conf.paliers.find(p => p.defaut) || conf.paliers[0];

  function peint() {
    tiers.forEach(t => {
      const on = +t.dataset.scbTier === choisi.n;
      t.classList.toggle('is-on', on);
      const r = t.querySelector('input'); if (r) r.checked = on;
    });
    const economie = enDevise(conf.plein * choisi.n - choisi.prix) + enDevise(conf.valeur_guides);
    eco.textContent = conf.txt.epargne.replace('{v}', argent(economie));
    btn.textContent = conf.txt.atc;
    err.classList.remove('is-on');
  }

  tiers.forEach(t => {
    const choisir = () => {
      choisi = conf.paliers.find(p => p.n === +t.dataset.scbTier);
      peint();
    };
    t.addEventListener('click', choisir);
    t.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choisir(); }
    });
  });

  /* ── l'ajout au panier ─────────────────────────────────────
     🔴 un verrou ASYNCHRONE : un drapeau synchrone ne marque pas une requête
     en vol, et le cadeau partait en double au double-clic. */
  let enVol = false;

  btn.addEventListener('click', async () => {
    if (enVol) return;
    enVol = true; btn.disabled = true;
    const ancien = btn.textContent;
    btn.textContent = conf.txt.ajout;
    try {
      /* 16/10 (règle Lucas) : une ligne de panier PAR casquette — la logistique lit les lignes ; la remise du palier se répartit dessus */
      const items = [];
      for (let n = 1; n <= choisi.n; n++) items.push({ id: conf.variante, quantity: 1, properties: { _l: String(n) } });
      conf.guides.forEach(g => items.push({
        id: g.vid, quantity: 1,
        properties: { _offre: 'lave-casquette', _pour: conf.titre }
      }));

      const drawer = document.querySelector('cart-drawer');
      const corps = { items: items.slice().reverse() };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        corps.sections = drawer.getSectionsToRender().map(s => s.id);
        corps.sections_url = window.location.pathname;
      }
      const rep = await fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(corps)
      });
      if (!rep.ok) throw new Error('ajout refusé : ' + rep.status);
      const data = await rep.json();

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();   // renderContents n'ouvre pas
        if (window.publish && window.PUB_SUB_EVENTS) {
          const panier = await (await fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')).json();
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'scb', cartData: panier });
        }
      } else {
        window.location.href = (window.routes ? window.routes.cart_url : '/cart');
      }
    } catch (e) {
      err.textContent = conf.txt.erreur;
      err.classList.add('is-on');
      console.error('[lave-casquette]', e);
    } finally {
      btn.textContent = ancien; btn.disabled = false; enVol = false;
    }
  });

  /* la barre collante reprend le bouton principal */
  const colle = document.querySelector('[data-scb-sticky]');
  if (colle) {
    colle.addEventListener('click', () => btn.click());
    const cible = racine.querySelector('[data-scb-atc]');
    new IntersectionObserver(([e]) => {
      colle.closest('[data-scb-sticky-bar]').classList.toggle('is-on', !e.isIntersecting);
    }, { rootMargin: '0px 0px -60px 0px' }).observe(cible);
  }

  peint();
})();

